 <template>
  <form class="newComm" @submit="create()" onsubmit="return false">
    <div class="form row column-s wrap">
      <div class="grid-3 grid-12-s column section">
        <div class="label">DATA DE ENVIO</div>
        <div class="row align-center">
          <input
            class="input"
            type="datetime-local"
            v-model="form.dh_agendamento_envio"
          />
        </div>
      </div>
      <div class="column grid-8-g grid-11-m grid-12-s">
        <div class="label">CANAIS</div>
        <div class="row wrap column-s justify-space">
          <div class="row align-center">
            <input type="checkbox" v-model="form.canal_prioritario" />
            Canal Prioritário &nbsp;
            <i class="fa fa-question-circle font-13 tip">
              <div>
                <p>
                  Não selecionar canal prioritário, fará com que cada supporter
                  recebe a mensagem em todos os canais que ele tiver habilitado.
                </p>
                <p>
                  Selecionar canal prioritário, fará com que cada supporter
                  receba apenas uma única mensagem, no canal habilitado que
                  tiver de maior prioridade, ou seja, de menor número.
                  <br /><br />

                  Exemplo:<br /><br />
                  => Contexto<br />
                  Canais disponíveis: Aplicativo como prioridade 1, Telegram com
                  prioridade 2, Slack com prioridade 3 e E-mail com prioridade 4
                  <br />
                  Supporter 1: Possui canais Telegram, E-mail<br />
                  Supporter 2: Possui canais Aplicativo, Telegram e E-mail<br />
                  Supporter 3: Possui apenas E-mail<br />
                  Supporter 4: Possui Todos os canais
                  <br /><br />

                  => Mensagem <br />
                  * Canais escolhidos: Aplicativo, Telegram e Slack<br /><br />
                  * Canal prioritário selecionado:<br />
                  - Supporter 1: Recebe apenas uma mensagem no canal Telegram<br />
                  - Supporter 2: Recebe apenas uma mensagem no canal
                  Aplicativo<br />
                  - Supporter 3: Não recebe nenhuma mensagem <br />- Supporter
                  4: Recebe apenas uma mensagem no canal Aplicativo <br /><br />

                  * Canal prioritário não selecionado: <br />
                  - Supporter 1: Recebe a mensagem no canal Telegram<br />
                  - Supporter 2: Recebe a mensagem nos canais Aplicativo e
                  Telegram<br />
                  - Supporter 3: Não recebe nenhuma mensagem <br />
                  - Supporter 4: Recebe a mensagem nos canais Aplicativo,
                  Telegram e Slack
                </p>
              </div>
            </i>
          </div>

          <div
            class="row align-center"
            v-for="(canal, prop) of canais"
            :key="canal + prop"
            @change="loadStats()"
          >
            <input type="checkbox" v-model="canais[prop].check" /> &nbsp;
            <div class="column card grid-12-s">
              <div class="name">
                {{ canal.nome }}
              </div>
              <span class="font-12">
                Prioridade: <b>{{ canal.prioridade }}</b></span
              >
              <span class="font-12" v-if="stats[prop]">
                Custo: <b>{{ stats[prop].custo }}</b
                ><br />
                Doutores: <b>{{ stats[prop].doutores }}</b>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row column-s grid-12 title-msg">
        <div class="grid-12-s" :class="subject ? 'grid-6' : 'grid-12'">
          <div class="label">TÍTULO</div>
          <input
            placeholder="Título"
            type="text"
            class="input"
            v-model="form.titulo"
          />
        </div>
        <div class="grid-6 grid-12-s subject" v-if="subject">
          <div class="label">ASSUNTO</div>
          <input
            type="text"
            placeholder="Assunto"
            class="input"
            v-model="form.assunto"
          />
        </div>
      </div>

      <div class="grid-12 column msg">
        <div class="label">MENSAGEM</div>
        <textarea
          class="textarea"
          v-model="form.mensagem"
          placeholder="Mensagem"
        ></textarea>
      </div>
    </div>

    <div class="divider"></div>
    <div class="row">
      <div class="grid-6">
        <Button
          type="button"
          class="createNewComm back"
          layout="white-m-gray"
          v-if="comm"
          @click="router.back()"
        >
          <i class="fa fa-arrow-left"></i> COMUNICADOS
        </Button>
      </div>
      <div class="grid-6 row justify-end">
        <Button
          class="updateComm createNewComm"
          layout="green-go"
          :loader="loader"
          v-if="!comm.processado"
          >ATUALIZAR</Button
        >
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Router from "@/router";

export default {
  name: "Comm",
  components: { Button },
  props: { comm: Object },
  data() {
    return {
      loader: false,
      router: Router,
      subject: false,
      showDrop: false,
      canais: {},
      stats: {},
      form: {},
    };
  },
  beforeMount() {
    this.LIST_CANAIS().then((r) => {
      if (r.data) {
        this.canais = r.data;
        for (let i of this.comm.canais) this.canais[i].check = true;
      }
    });

    if (this.comm) {
      this.form = this.comm;
      this.showDrop = true;
      if (this.comm.assunto) this.subject = true;
    }
  },
  methods: {
    ...mapActions("admin", [
      "UPDATE_COMM_SUPPORTER",
      "STATS_COMMUNICATION",
      "LIST_CANAIS",
    ]),
    loadStats() {
      let canais = [];
      this.subject = false;

      for (let canal in this.canais) {
        if (this.canais[canal].requer_assunto && this.canais[canal].check)
          this.subject = true;
        if (this.canais[canal].check) canais.push(canal);
      }

      if (!this.subject) this.form.assunto = "";

      this.STATS_COMMUNICATION({
        canais: canais,
        canal_prioritario: this.form.canal_prioritario,
      }).then((r) => (this.stats = r && r.data ? r.data : this.stats));
    },
    create() {
      this.loader = true;
      this.form.canais = [];
      for (let i in this.canais)
        this.canais[i].check && this.form.canais.push(i);
      this.form.dh_agendamento_envio = this.form.dh_agendamento_envio.replace(
        "T",
        " "
      );

      this.UPDATE_COMM_SUPPORTER(this.form)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.newComm {
  color: $gray-6;
  background: $white;
  margin-top: 1rem;
  border-radius: 5px;
  padding: 25px;
  box-shadow: $shadow;

  font-size: 15px;
  font-weight: 300;
  .sub {
    border-radius: 5px;
    font-size: 16px;
    color: #bbb;
    font-weight: bold;
  }
  .label {
    font-weight: bold;
    color: $gray-9;
    font-size: 12px;
    margin: 10px 0px;

    @media (max-width: $small) {
      margin-top: 30px;
    }
  }
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
  }
  .section {
    @media (min-width: $small) {
      margin-right: 70px;
    }
  }
  .input {
    width: 94%;
    margin-bottom: 20px;
    margin-top: 5px;
  }
  select {
    width: 98.1% !important;
  }
  .title {
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  &.close {
    height: 0px;
    overflow: hidden;
    opacity: 0;
  }
  &.open {
    margin-top: 20px;
    margin-bottom: 3rem;
    @media (min-width: $small) {
      height: 565px;
    }
  }
  .back {
    font-size: 13px;
    font-weight: bold;
    padding: 7px;
  }

  .divider {
    margin-top: 25px;
  }
  .createNewComm {
    margin-top: 20px;
  }
  .publish {
    height: 32px;
    margin-left: 18px;
  }
  .closeNewComm {
    text-align: right;
    margin-top: -12px;
    cursor: pointer;
    font-size: 35px;
    &:hover {
      color: $red-1;
    }
  }
}
</style>